import { render, staticRenderFns } from "./ChildProfile.vue?vue&type=template&id=3f524ba0&"
import script from "./ChildProfile.vue?vue&type=script&lang=js&"
export * from "./ChildProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports